/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowlogonone3Inputs */

const en_aiflowlogonone3 = /** @type {(inputs: Aiflowlogonone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No logo`)
};

const de_aiflowlogonone3 = /** @type {(inputs: Aiflowlogonone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohne Logo`)
};

/**
* | output |
* | --- |
* | "No logo" |
*
* @param {Aiflowlogonone3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowlogonone3 = /** @type {((inputs?: Aiflowlogonone3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowlogonone3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowlogonone3(inputs)
	return de_aiflowlogonone3(inputs)
});
export { aiflowlogonone3 as "aiFlowLogoNone" }